import React from "react";
import { InfoSection } from "../components/info-section/InfoSection";
import { targetClientsData } from "../constants/siteData";

export const TargetClients = () => {
  return <InfoSection data={targetClientsData} />;
};
